<template>
    <BasicTile class="payout-denomination pa-2 w-100 dark-overlay" rounded="rounded-12"
        :style="{ 'background-image': `url(${selectedPayoutOption.option.icon})` }"
        v-primary-border="selectedDenomination?.id === denominationId"
        v-primary-glow="selectedDenomination?.id === denominationId" @click="$emit('click')">
        
        
        <div class="payout-denomination__content">

            <div class="payout-denomination__amount-wrapper">
                <span class="payout-denomination__currency">
                    <slot name="currency"></slot>
                </span>
                <span class="payout-denomination__amount">
                    <slot name="amount"></slot>
                </span>
            </div>


            <div class="payout-denomination__coins-wrapper">
                <v-icon>
                    <coin></coin>
                </v-icon>
                <span class="payout-denomination__coins">
                    <slot name="coins"></slot>
                </span>
            </div>

        </div>
    </BasicTile>
</template>



<script setup lang="ts">

import Coin from "@/icons/Coin.vue";
import { computed } from 'vue';
import { PayoutStore } from '@/store/PayoutStore';
import BasicTile from '@/components/Tiles/Basic-Tile.vue';


const props = defineProps({
    denominationId: {
        type: Number,
        required: true
    }
});

const payoutStore = PayoutStore();

const selectedDenomination = computed(() => {
    return payoutStore.SelectedDenomination || {}
});

const selectedPayoutOption = computed(() => {
    return payoutStore.SelectedPayoutOption || {}
});

</script>